import { render, staticRenderFns } from "./InvestorListModal.vue?vue&type=template&id=b89d94da&"
import script from "./InvestorListModal.vue?vue&type=script&lang=js&"
export * from "./InvestorListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports